// https://css-tricks.com/overlaying-video-with-transparency-while-wrangling-cross-browser-support/

function supportsHEVCAlpha() {
  const navigator = window.navigator;
  const ua = navigator.userAgent.toLowerCase();
  const hasMediaCapabilities = !!(
    navigator.mediaCapabilities && navigator.mediaCapabilities.decodingInfo
  );
  const isSafari =
    ua.indexOf('safari') !== -1 &&
    ua.indexOf('chrome') === -1 &&
    ua.indexOf('version/') !== -1;
  return isSafari && hasMediaCapabilities;
}

function setupTransparentVideo(el) {
  if (supportsHEVCAlpha()) {
    const source = el.querySelector('source');
    el.src = source.src.replace('.webm', '.mov');
    source.remove();
  }
}

export function init() {
  const videos = document.querySelectorAll('[data-js-transparent-video]');

  [...videos].forEach((el) => setupTransparentVideo(el));
}
